import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock9 as Block } from "./HomepageBlock9";
import { defaultData } from "./HomepageBlock9DefaultData";
import { meta } from "./HomepageBlock9MetaData";
import imagePreview from "./homepage_block_9_preview.png";

export const HomepageBlock9: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
